// const log = console.log;
// console.log = () => {};
// const __ = require('./live2dsdk');
// console.log = log;

export {
  UtSystem,
  UtDebug,
  LDTransform,
  LDGL,
  Live2D,
  Live2DModelWebGL,
  Live2DModelJS,
  Live2DMotion,
  MotionQueueManager,
  PhysicsHair,
  AMotion,
  PartsDataID,
  DrawDataID,
  BaseDataID,
  ParamID
};



// WEBPACK FOOTER //
// ./src/lib/live2d.js